module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_audit_sample-c031a41ec666be7d3b2f0e06e6227dbd.jpg";